
<header class="sticky-header">
  <div class="header-container">
    <a href="#hero" appScrollSpy spySectionId="hero" class="logo">
@if(isDarkMode) {

  <img
  width="200"
  height="60"
    src="/logo-dark.svg"
    alt="cloudfusion-it Logo (Dark)"
   class="responsive-img"
  />

} @else { 


  <img
  width="200"
  height="60"
    src="/logo-light.svg"
    alt="cloudfusion-it Logo (Light)"
    class="responsive-img"
  />
 

}


        </a>

    <nav class="desktop-menu">
      <a href="#about" appScrollSpy spySectionId="about">{{ 'NAV.ABOUT' | translate }}</a>
      <a href="#services" appScrollSpy spySectionId="services">{{ 'NAV.SERVICES' | translate }}</a>
      <a href="#projects" appScrollSpy spySectionId="projects">{{ 'NAV.PROJECTS' | translate }}</a>
      <a href="#testimonials" appScrollSpy spySectionId="testimonials">{{ 'NAV.TESTIMONIALS' | translate }}</a>
      <a href="#technologies" appScrollSpy spySectionId="technologies">{{ 'NAV.TECHNOLOGIES' | translate }}</a>
      <a href="#chatbot" appScrollSpy spySectionId="chatbot">{{ 'NAV.CHATBOT' | translate }}</a>
      <a href="#blog" appScrollSpy spySectionId="blog">{{ 'NAV.BLOG' | translate }}</a>
      
      <a class="contact-button" href="#contact">{{ 'NAV.CONTACT' | translate }}</a>

      <div class="language-switcher">
        <button (click)="setLanguage('de')" [class.active]="currentLang === 'de'" aria-label="Sprache Deutsch">🇩🇪</button>
        <button (click)="setLanguage('en')" [class.active]="currentLang === 'en'" aria-label="Language English">🇬🇧</button>
      </div>
      
    </nav>

    <button
    class="hamburger-button"
    (click)="toggleMobileMenu()"
    [class.active]="isMobileMenuOpen"
    aria-label="Menü öffnen oder schließen"
  >
    <svg class="hamburger-icon" viewBox="0 0 100 100" width="40" height="40">
      <rect class="line top" width="80" height="8" x="10" y="25" rx="4" />
      <rect class="line middle" width="80" height="8" x="10" y="46" rx="4" />
      <rect class="line bottom" width="80" height="8" x="10" y="67" rx="4" />
    </svg>
  </button>
  
  </div>

  <div class="mobile-menu" [class.open]="isMobileMenuOpen">
    <a href="#about" (click)="closeMenu()">{{ 'NAV.ABOUT' | translate }}</a>
    <a href="#services" (click)="closeMenu()">{{ 'NAV.SERVICES' | translate }}</a>
    <a href="#projects" (click)="closeMenu()">{{ 'NAV.PROJECTS' | translate }}</a>
    <a href="#testimonials" (click)="closeMenu()">{{ 'NAV.TESTIMONIALS' | translate }}</a>
    <a href="#technologies" (click)="closeMenu()">{{ 'NAV.TECHNOLOGIES' | translate }}</a>
    <a href="#contact" (click)="closeMenu()">{{ 'NAV.CONTACT' | translate }}</a>
    <a href="#chatbot" (click)="closeMenu()">{{ 'NAV.CHATBOT' | translate }}</a>
    <a routerLink="/blog"  (click)="scrollToTop($event)">
      {{ 'NAV.BLOG' | translate }}
    </a>
    
    <div class="language-switcher">
      <button (click)="setLanguage('de')" [class.active]="currentLang === 'de'" aria-label="Sprache Deutsch">🇩🇪</button>
      <button (click)="setLanguage('en')" [class.active]="currentLang === 'en'" aria-label="Language English">🇬🇧</button>
    </div>
    
  </div>
</header>
